import Head from "next/head";
import { NextSeo } from "next-seo";
import dynamic from "next/dynamic";
import { SliceZone } from "@prismicio/react";
import { Header } from "components/headers/Header";
import Footer from "components/footer/Footer";
import BackgroundGlassmorphism from "components/backgrounds/BackgroundGlassmorphism";

const components = {
  text_section_with_image: dynamic(() =>
    import("../slices/TextSectionWithImage")
  ),
  search_hero: dynamic(() => import("../slices/SearchHero")),
  holiday_destinations_holland: dynamic(() =>
    import("../slices/HolidayDestinationsHolland")
  ),
  popular_holiday_destinations_europe: dynamic(() =>
    import("../slices/PopularHolidayDestinationsEurope")
  ),
};

const LandingPageTemplate = ({ page }) => {
  const {
    title,
    description,
    openGraphTitle,
    openGraphDesc,
    openGraphImage,
    slices3,
  } = page.data;

  return (
    <div className="nc-PageHome relative overflow-hidden">
      <Head>
        <meta name="robots" content="all" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
      </Head>
      <NextSeo
        title={`${
          title ? title : "De vakantiehuizen website van Europa"
        } | TopVakantiehuizen.eu`}
        description={
          description
            ? description
            : "Op zoek naar een vakantiehuis in Europa? Op TopVakantiehuizen.eu vind jij het perfecte vakantiehuis! Boek veilig & snel bij TopVakantiehuizen.eu!"
        }
        canonical={`https://www.topvakantiehuizen.eu/${page.uid}`}
        openGraph={{
          url: `https://www.topvakantiehuizen.eu/${page.uid}`,
          title: `${
            openGraphTitle
              ? openGraphTitle
              : "De vakantiehuizen website van Europa"
          } | TopVakantiehuizen.eu`,
          description: `${
            openGraphDesc
              ? openGraphDesc
              : "Op zoek naar een vakantiehuis in Europa? Op TopVakantiehuizen.eu vind jij het perfecte vakantiehuis! Boek veilig & snel bij TopVakantiehuizen.eu!"
          }`,
          images: [
            {
              url: openGraphImage?.url
                ? openGraphImage.url
                : "https://www.topvakantiehuizen.eu/assets/logo/TopVakantiehuizen.eu.png",
            },
          ],
          site_name: "TopVakantiehuizen.eu",
        }}
        twitter={{
          handle: "@handle",
          site: "@site",
          cardType: "summary_large_image",
        }}
      />
      <Header />
      <BackgroundGlassmorphism />
      <main className="container relative mb-24 space-y-24 lg:mb-32 lg:space-y-32">
        <SliceZone slices={slices3} components={components} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPageTemplate;
